import ValidateDate from './validators/date-validator';

class Validation {
	constructor($timeout, $rootScope, $templateCache) {
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.$templateCache = $templateCache;

		this.scope = {
			for: '='
		};
		this.restrict = 'E';
		this.transclude = true;
		this.link = this.ValidationLink;
		this.template = this.$templateCache.get('templates/validation/validation-tmpl.html');
	}

	/**
	 * The directive's Link function
	 * 
	 * @param {ng.IScope} scope 
	 * @param {HTMLElement} element 
	 * @param {object} attrs 
	 * 
	 * @memberOf Validation
	 */
	ValidationLink(scope, element, attrs) {
		const $element = angular.element(element);

		const inputName = attrs.for;

		let input = angular.element(`[name='${inputName}']`, $element.parent()).get(0);
		if (!input) {
			input = angular.element(`#${inputName}`, $element.parent()).get(0);
		}
		const $input = angular.element(input);

		const form = $element.closest('form');
		const $form = angular.element(form);
		const formName = $form.attr('name');

		let isDirty = scope.$parent[formName][inputName].$dirty;

		this.$timeout(() => {
			if (isDirty && scope.$parent[formName][inputName].$invalid) {
				this.showValidationErrors($element, $input, scope.$parent[formName][inputName].$error);
			} else {
				this.hideValidationErrors($element, $input);
			}

			$input.on('input', () => this.processErrorHandling(scope, $element, $input, isDirty, formName, inputName));
			if ($input.attr('data-is-date-picker')) {
				$input.on('changeDate', () =>
					this.processErrorHandling(scope, $element, $input, isDirty, formName, inputName)
				);
			}
		});
	}

	processErrorHandling(scope, $element, $input, isDirty, formName, inputName) {
		if (!$input.attr('multi-max-length')) {
			this._handleNormalErrors(scope, $element, $input, isDirty, formName, inputName);
		} else {
			angular.element(`form[name='${formName}'] [multi-max-length]`).each((i, el) => {
				inputName = angular.element(el).attr('name');
				let hasErrors = false;
				isDirty = scope.$parent[formName][inputName].$dirty;
				if (isDirty) {
					if (scope.$parent[formName][inputName].$invalid) {
						hasErrors = true;
					}
				}

				$input = angular.element(el);
				$element = angular.element(`validation[for='${inputName}']`);
				if (hasErrors) {
					this.showValidationErrors($element, $input, scope.$parent[formName][inputName].$error);
				} else {
					this.hideValidationErrors($element, $input);
				}
			});
		}
	}

	_handleNormalErrors(scope, $element, $input, isDirty, formName, inputName) {
		let hasErrors = false;
		isDirty = scope.$parent[formName][inputName].$dirty;
		if (isDirty) {
			if (scope.$parent[formName][inputName].$invalid) {
				hasErrors = true;
			}
		}

		if ($input.attr('data-is-date-picker')) {
			const isValidDate = ValidateDate($input.val());

			if (!isValidDate) {
				scope.$parent[formName][inputName].$error.datepicker = true;
			} else {
				delete scope.$parent[formName][inputName].$error.datepicker;
			}
		}

		if (hasErrors) {
			this.showValidationErrors($element, $input, scope.$parent[formName][inputName].$error);
		} else {
			this.hideValidationErrors($element, $input);
		}
	}

	/**
	 * Method for removing input's validation errors from the screen
	 * 
	 * @param {JQuery} $element 
	 * @param {JQuery} $input
	 * 
	 * @memberOf Validation
	 */
	hideValidationErrors($element, $input) {
		this.$timeout(() => {
			$input.removeClass('error');

			$element.css('display', 'none');
		});
	}

	/**
	 * Method for showing input's validation errors
	 * 
	 * @param {JQuery} $element 
	 * @param {JQuery} $input 
	 * @param {object} errors 0
	 * 
	 * @memberOf Validation
	 */
	showValidationErrors($element, $input, errors) {
		this.$timeout(() => {
			$input.removeClass('error').addClass('error');

			Object.keys(errors).forEach((key) => {
				const value = errors[key];
				if (value === true) {
					this.$timeout(() => {
						angular.element('error', $element).each((index, error) => {
							const $error = angular.element(error);
							if ($error.attr('type') === key) {
								$error.css('display', 'block');
							} else {
								$error.css('display', 'none');
							}
						});
					});
				}
			});

			$element.css('display', 'block');
		});
	}
}

export default /* @ngInject */ ($timeout, $rootScope, $templateCache) =>
	new Validation($timeout, $rootScope, $templateCache);
